import {createSlice, PayloadAction} from '@reduxjs/toolkit';

import set from 'lodash/set';
import map from 'lodash/map';
import unset from 'lodash/unset';

import {changeField, clearContext} from 'client/common/store/reducers/context/brandlift';

const initialState: any = {};

interface SetErrorsPayload {
    [object: string]: any;
}

const slice = createSlice({
    name: 'errors',
    initialState,
    reducers: {
        setErrors(state, action: PayloadAction<SetErrorsPayload>) {
            if (!action.payload) {
                return state;
            }

            return {
                ...action.payload
            };
        }
    },
    extraReducers: builder =>
        builder
            // eslint-disable-next-line complexity, max-statements
            .addCase(changeField, (state, action) => {
                const {field, value} = action.payload;

                if (
                    !Array.isArray(field) &&
                    (field.startsWith('metricOptions.')
                        || field.startsWith('metricLabels.')
                        || field.startsWith('metricPlaceholders.'))
                ) {
                    const [branch, metricName] = field.split('.');

                    if (branch === 'metricLabels') {
                        unset(state, `customFormulations.${metricName}.label`);
                    }
                    if (branch === 'metricPlaceholders') {
                        unset(state, `customFormulations.${metricName}.placeholder`);
                    }
                    if (branch === 'metricOptions') {
                        map(value, (option, index) => {
                            if (option) {
                                unset(state, `customFormulations.${metricName}.options.${index}`);
                            }
                        });
                    }

                    return;
                }

                if (field === 'isCustomFormulations') {
                    if (value === false) {
                        unset(state, 'customFormulations');
                    }

                    return;
                }

                if (field === 'logos' || field === 'isLogoUploaderEnabled') {
                    if (value === false) {
                        unset(state, 'logos');
                    }
                    
                    return;
                }

                if (state) {
                    set(state, field, null);
                }
            })
            .addCase(clearContext, () => {
                return {};
            })
});

const {actions, reducer} = slice;

export const {setErrors} = actions;
export default reducer;
